// const BaseURL = window.location.origin
const BaseURL = process.env.NODE_ENV == 'development' ? 'http://192.168.2.152:9001': 'http://mqhb.bidanet.com'


export default BaseURL;
